const jQuery = require('jquery');
window.$ = window.jQuery = jQuery;

require('../libs/bootstrap/transition');
require('../libs/bootstrap/collapse');
require('../libs/bootstrap/modal');

jQuery.noConflict(true);



// WEBPACK FOOTER //
// ./scripts/bootstrapComponents.js